// extracted by mini-css-extract-plugin
module.exports = {"RV-F":"F2_RV-F__MAL_g"};